import React from 'react';
import styles from '../Operations.module.css';

interface AHFComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * FULFILLMENT - acehardware.com Fulfillment
 * KPI information component
 */
const AHF: AHFComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Acehardware.com Fulfillment is the measurement of a store&apos;s participation in all three achardware.com services (Buy Online, Pick Up in Store | Buy Online, Deliver from Store | Assembly).<br/><br/>
        This metric will count the number of days a store is NOT active on all three services within the calendar year.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        A store must remain active in all three services every day that the store is open in the calendar year to meet consumer demand.<br/><br/> Exceptions:
        <ul style={{ marginTop: 0, paddingLeft: '2rem' }}>
          <li>An exception exists allowing a maximum of 24 inactive days when a store can turn off any one of the services in My Store.</li>
          <li>In My Store, there are two retailer controls allowing for stores to suppress Buy Online, Delivery from Store orders.</li>
          <li>The &apos;Delivery Day of Week Exclusion&apos; allows a retailer to set one day per week when they do not offer Delivery. Utilizing this feature DOES NOT count against the 24 allowable days turned off per year.</li>
          <li>The &apos;Delivery Date Exclusion&apos; allows for retailers to utilize a calendar interface and turn Delivery off for a specific day. Utilizing this feature DOES count against the 24 allowable days turned off per year.</li>
        </ul>
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Pinnacle Goal: Participate in BOPIS, BODFS, Assembly, and not exceed 24 Delivery Date Exclusions per year.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Leverage our reference landing page at the following path for instructions on how to manage your <strong>My Store</strong> settings and review reference information for acehardware.com fulfillment processes<br/>
        <a href="https://acenet.aceservices.com/marketing/digital-marketing/acehardwarecom/acehardwarecom-order-fulfillment-types" target="_blank" rel="noopener noreferrer" className={styles.link}>ACENET &gt; Marketing &gt; Digital Marketing &gt; acehardware.com &gt; Order Fulfillment Types: BOPIS/Curbside/BODFS/Assembly</a><br/><br/>
        Or email Ecom@acehardware.com for assistance
      </div>
    </div>
  );
};

AHF.title = 'acehardware.com Fulfillment';
AHF.actionTitle = 'Review Days Turned Off';
AHF.actionHyperlink = 'dynamicURL:WFC:current';
export default AHF;

